module.exports = __webpack_public_path__ + "70cf66683f38145c84d89664947ca065.pdf";


//////////////////
// WEBPACK FOOTER
// ./app/assets/data/calendar/calendar_fr.pdf
// module id = 925
// module chunks = 3